import {
    INITIALIZE_EVENT,
    SAVE_EVENT_SHIPPING_RATES,
    SAVE_EVENT_SHIPPING_SETTINGS,
    UPDATE_EVENT_PRIVACY_SETTING,
    UPDATE_AVAILABLE_INSTALLMENTS,
} from '../actions/event';
import { MARK_WAITLIST_FULL } from '../actions/waitlist';

export const eventReducer = (state = {}, action) => {
    switch (action.type) {
        case INITIALIZE_EVENT:
            return {
                ...state,
                ...action.payload.event,
            };

        case SAVE_EVENT_SHIPPING_SETTINGS:
            return {
                ...state,
                ...action.payload,
            };

        case MARK_WAITLIST_FULL:
            return {
                ...state,
                waitlistSettings: {
                    ...state.waitlistSettings,
                    full: true,
                },
            };

        case UPDATE_EVENT_PRIVACY_SETTING:
            return {
                ...state,
                privacySetting: action.payload,
            };

        case UPDATE_AVAILABLE_INSTALLMENTS:
            return {
                ...state,
                installments: action.payload,
            };

        case SAVE_EVENT_SHIPPING_RATES:
            return {
                ...state,
                shippingRates: action.payload.shipping_rates,
            };

        default:
            return state;
    }
};
